var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconXInCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_x-in-circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remove-/-black-/-icon_x-in-circle",
    transform: "translate(-2.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_x-in-circle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cross",
    transform: "translate(2.000000, 2.000000)",
    fill: "#f25a5a",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.86368421,14.7258007 C6.60102579,14.7273333 6.36368853,14.5693843 6.26370002,14.3264972 C6.16371152,14.0836102 6.22106328,13.8043475 6.40868421,13.6205263 L13.6315789,6.40868421 C13.8833772,6.15688597 14.2916228,6.15688597 14.5434211,6.40868421 C14.7952193,6.66048246 14.7952193,7.06872807 14.5434211,7.32052632 L7.31868421,14.5360526 C7.19825477,14.6572453 7.03453745,14.7255161 6.86368421,14.7258007 L6.86368421,14.7258007 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0792105,14.7257895 C13.909149,14.7269838 13.7455426,14.6607463 13.6242105,14.5415789 L6.40684211,7.32052632 C6.15504387,7.06872807 6.15504387,6.66048246 6.40684211,6.40868422 C6.65864035,6.15688598 7.06688596,6.15688597 7.31868421,6.40868421 L14.5360526,13.6315789 C14.7236736,13.8154001 14.7810253,14.0946628 14.6810368,14.3375498 C14.5810483,14.5804369 14.343711,14.738386 14.0810526,14.7368533 L14.0792105,14.7257895 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4723684,20.8968421 C4.71610795,20.8968421 0.0497368421,16.230471 0.0497368421,10.4742105 C0.0497368421,4.71795005 4.71610795,0.0515789474 10.4723684,0.0515789474 C16.2286289,0.0515789474 20.895,4.71795005 20.895,10.4742105 C20.8878953,16.2275255 16.2256834,20.8897374 10.4723684,20.8968421 Z M10.4723684,1.33921053 C5.4282646,1.33921053 1.33921053,5.4282646 1.33921053,10.4723684 C1.33921053,15.5164722 5.4282646,19.6055263 10.4723684,19.6055263 C15.5164722,19.6055263 19.6055263,15.5164722 19.6055263,10.4723684 C19.5994362,5.43078935 15.5139475,1.34530062 10.4723684,1.33921053 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXInCircle);
export default __webpack_public_path__ + "static/media/icon_x-in-circle.9207c306cadbd23f093b2dfa158e1021.svg";
export { ForwardRef as ReactComponent };